// Sprachen der Oberfläche: Deutsch (Quelle), Suomi, English.
// t('deutscher Text', { platzhalter }) liefert den Text in der gewählten Sprache; fehlt ein Eintrag,
// bleibt der deutsche Text stehen. Die Wahl gilt pro Browser (localStorage), ?lang=fi setzt sie per URL.
export type Lang = 'de' | 'fi' | 'en';
import { MORE } from './i18n-more';
import { MODES } from './i18n-modes';
import { BOTS } from './i18n-bots';
import { COACH } from './i18n-coach';
import { GUESS } from './i18n-guess';
import { PUZZLE } from './i18n-puzzle';
import { APP } from './i18n-app';

export const LANGS: Lang[] = ['fi', 'en', 'de'];

// [Suomi, English]
const D: Record<string, [string, string]> = {
  // Navigation und Kopf
  'Bibliothek': ['Kirjasto', 'Library'],
  'Analyse': ['Analyysi', 'Analysis'],
  'Foto': ['Kuva', 'Photo'],
  'Brett-Editor': ['Lautaeditori', 'Board editor'],
  'Wallpaper': ['Taustakuva', 'Wallpaper'],
  'Setup': ['Asetukset', 'Setup'],
  'Sprache': ['Kieli', 'Language'],
  'Importierte Partien durchsuchen, nachspielen und analysieren.': ['Selaa, toista ja analysoi tuotuja pelejä.', 'Browse, replay and analyse imported games.'],
  'Stellung aus einem Bildschirmfoto oder Buchdiagramm erkennen.': ['Tunnista asema kuvakaappauksesta tai kirjan diagrammista.', 'Recognise a position from a screenshot or a book diagram.'],
  'Stellung aufbauen, prüfen und analysieren.': ['Rakenna asema, tarkista ja analysoi.', 'Set up, check and analyse a position.'],
  'Partien auf dem schwarzen Desktop, Zug für Zug.': ['Pelit mustalla työpöydällä siirto siirrolta.', 'Games on a black desktop, move by move.'],
  'Autostart, Engine, Daten und Lizenzen.': ['Automaattikäynnistys, moottori, tiedot ja lisenssit.', 'Autostart, engine, data and licences.'],
  'Läuft offline auf diesem Rechner · GPL-3.0': ['Toimii offline tällä koneella · GPL-3.0', 'Runs offline on this computer · GPL-3.0'],
  'Freie Analyse': ['Vapaa analyysi', 'Free analysis'],
  'Partie': ['Peli', 'Game'],
  'lade …': ['ladataan …', 'loading …'],
  '{n} Züge': ['{n} siirtoa', '{n} moves'],

  // Bibliothek
  'Bibliothek nicht geladen: {e}': ['Kirjastoa ei voitu ladata: {e}', 'Library not loaded: {e}'],
  'Import fehlgeschlagen: {e}': ['Tuonti epäonnistui: {e}', 'Import failed: {e}'],
  '{a} von {b} Partien importiert': ['{a}/{b} peliä tuotu', '{a} of {b} games imported'],
  '{n} waren schon da': ['{n} oli jo kirjastossa', '{n} were already there'],
  '1 Partie mit Fehlern (bis zum Fehler übernommen oder übersprungen)': ['1 virheellinen peli (tuotu virheeseen asti tai ohitettu)', '1 game with errors (imported up to the error or skipped)'],
  '{n} Partien mit Fehlern (bis zum Fehler übernommen oder übersprungen)': ['{n} virheellistä peliä (tuotu virheeseen asti tai ohitettu)', '{n} games with errors (imported up to the error or skipped)'],
  'Partie {i}': ['Peli {i}', 'Game {i}'],
  'Importiere …': ['Tuodaan …', 'Importing …'],
  'PGN importieren': ['Tuo PGN', 'Import PGN'],
  'Dateien hierher ziehen oder klicken. Sammeldateien werden in einzelne Partien zerlegt.': ['Vedä tiedostot tähän tai napsauta. Kokoelmatiedostot jaetaan yksittäisiksi peleiksi.', 'Drag files here or click. Collection files are split into single games.'],
  'Einfügen schließen': ['Sulje liittäminen', 'Close paste'],
  'PGN einfügen': ['Liitä PGN', 'Paste PGN'],
  'Suchen: Spieler, Ereignis, Ort, Jahr': ['Hae: pelaaja, tapahtuma, paikka, vuosi', 'Search: player, event, place, year'],
  'Bibliothek durchsuchen': ['Hae kirjastosta', 'Search the library'],
  '{a} von {b}': ['{a} / {b}', '{a} of {b}'],
  'PGN-Text': ['PGN-teksti', 'PGN text'],
  'Importieren': ['Tuo', 'Import'],
  'Weiß': ['Valkea', 'White'],
  'Schwarz': ['Musta', 'Black'],
  'Jahr': ['Vuosi', 'Year'],
  'Ergebnis': ['Tulos', 'Result'],
  'Ereignis': ['Tapahtuma', 'Event'],
  'Züge': ['Siirrot', 'Moves'],
  'gekürzt': ['lyhennetty', 'truncated'],
  'ausgewertet': ['analysoitu', 'analysed'],
  'Im Wallpaper abspielen': ['Toista taustakuvassa', 'Play in the wallpaper'],
  'Wirklich löschen?': ['Poistetaanko varmasti?', 'Really delete?'],
  'Löschen': ['Poista', 'Delete'],
  'Weitere laden': ['Lataa lisää', 'Load more'],
  'Keine Partie passt zur Suche.': ['Yksikään peli ei vastaa hakua.', 'No game matches the search.'],
  'Noch keine Partien. Importiere eine PGN-Datei.': ['Ei vielä pelejä. Tuo PGN-tiedosto.', 'No games yet. Import a PGN file.'],

  // Analyse
  'Partie nicht geladen: {e}': ['Peliä ei voitu ladata: {e}', 'Game not loaded: {e}'],
  'Die Stellung (FEN) ist ungültig.': ['Asema (FEN) on virheellinen.', 'The position (FEN) is invalid.'],
  'Auswertung nicht geladen: {e}': ['Analyysia ei voitu ladata: {e}', 'Review not loaded: {e}'],
  'Varianten nicht gespeichert: {e}': ['Muunnelmia ei tallennettu: {e}', 'Variations not saved: {e}'],
  'Tiefe {d}': ['Syvyys {d}', 'Depth {d}'],
  'rechnet …': ['laskee …', 'thinking …'],
  'Engine an/aus (l)': ['Moottori päälle/pois (l)', 'Engine on/off (l)'],
  'Drohung': ['uhka', 'threat'],
  'Tastatur': ['Näppäimistö', 'Keyboard'],
  '← →  oder  k j': ['← →  tai  k j', '← →  or  k j'],
  '↑ ↓  oder  0 $': ['↑ ↓  tai  0 $', '↑ ↓  or  0 $'],
  'Zug zurück / vor': ['Siirto taakse / eteen', 'Move back / forward'],
  'Anfang / Ende': ['Alku / loppu', 'Start / end'],
  'Leertaste': ['Välilyönti', 'Space'],
  'besten Zug spielen (Engine aus: einschalten)': ['pelaa paras siirto (moottori pois: kytke päälle)', 'play the best move (engine off: switch it on)'],
  'Engine an / aus': ['Moottori päälle / pois', 'Engine on / off'],
  'Engine-Pfeile an / aus': ['Moottorin nuolet päälle / pois', 'Engine arrows on / off'],
  'Drohung zeigen': ['Näytä uhka', 'Show threat'],
  'Brett drehen': ['Käännä lauta', 'Flip board'],
  'diese Hilfe': ['tämä ohje', 'this help'],
  'Anfang (↑)': ['Alku (↑)', 'Start (↑)'],
  'Zurück (←)': ['Taakse (←)', 'Back (←)'],
  'Vor (→)': ['Eteen (→)', 'Forward (→)'],
  'Ende (↓)': ['Loppu (↓)', 'End (↓)'],
  'Brett drehen (f)': ['Käännä lauta (f)', 'Flip board (f)'],
  'Variante löschen': ['Poista muunnelma', 'Delete variation'],
  'Ohne Grenze rechnen, bis du weiterziehst': ['Laske rajatta, kunnes siirryt eteenpäin', 'Keep calculating until you move on'],
  'unbegrenzt rechnen': ['laske rajatta', 'unlimited analysis'],
  'Stellung bearbeiten': ['Muokkaa asemaa', 'Edit position'],
  'Tasten (?)': ['Näppäimet (?)', 'Keys (?)'],
  'Die PGN enthält einen ungültigen Zug. Gezeigt wird die Partie bis dahin. ({e})': ['PGN sisältää virheellisen siirron. Peli näytetään siihen asti. ({e})', 'The PGN contains an invalid move. The game is shown up to that point. ({e})'],
  'lade Partie …': ['ladataan peliä …', 'loading game …'],
  'Stockfish nicht gefunden ({p}).': ['Stockfishia ei löytynyt ({p}).', 'Stockfish not found ({p}).'],

  // Computeranalyse
  'Ungenauigkeit': ['Epätarkkuus', 'Inaccuracy'],
  'Fehler': ['Virhe', 'Mistake'],
  'Grober Fehler': ['Vakava virhe', 'Blunder'],
  'Besser war {m}.': ['Parempi oli {m}.', 'Best was {m}.'],
  'Bewertungsverlauf': ['Arviokäyrä', 'Evaluation graph'],
  'Auswertung abgebrochen: {e}': ['Analyysi keskeytyi: {e}', 'Review aborted: {e}'],
  'unbekannter Fehler': ['tuntematon virhe', 'unknown error'],
  'Für die Computeranalyse wird Stockfish gebraucht.': ['Tietokoneanalyysi tarvitsee Stockfishin.', 'Computer analysis needs Stockfish.'],
  'Computeranalyse neu starten': ['Käynnistä tietokoneanalyysi uudelleen', 'Restart computer analysis'],
  'Computeranalyse starten': ['Käynnistä tietokoneanalyysi', 'Start computer analysis'],
  'Stockfish bewertet Stellung {a} von {b} ({n} Mio. Knoten je Stellung) …': ['Stockfish arvioi asemaa {a}/{b} ({n} milj. solmua asemaa kohden) …', 'Stockfish is evaluating position {a} of {b} ({n} M nodes per position) …'],
  'Ø Verlust': ['Ø menetys', 'Avg. loss'],
  'Genauigkeit': ['Tarkkuus', 'Accuracy'],
  'Ungenauigkeit ?!, Fehler ?, grober Fehler ??; Ø Verlust in Hundertstel-Bauern; Genauigkeit in %. Berechnet wie auf lichess.': ['Epätarkkuus ?!, virhe ?, vakava virhe ??; Ø menetys sadasosasotilaina; tarkkuus prosentteina. Laskettu kuten lichessissä.', 'Inaccuracy ?!, mistake ?, blunder ??; avg. loss in centipawns; accuracy in %. Calculated as on lichess.'],

  // Brett-Editor
  'Diese FEN kann ich nicht lesen.': ['Tätä FEN-merkkijonoa ei voi lukea.', 'This FEN cannot be read.'],
  'Ungültige Stellung.': ['Virheellinen asema.', 'Invalid position.'],
  'Jede Seite braucht genau einen König.': ['Kummallakin puolella on oltava täsmälleen yksi kuningas.', 'Each side needs exactly one king.'],
  'Bauern dürfen nicht auf der ersten oder letzten Reihe stehen.': ['Sotilaat eivät voi olla ensimmäisellä tai viimeisellä rivillä.', 'Pawns cannot stand on the first or last rank.'],
  'Die Seite, die nicht am Zug ist, steht im Schach.': ['Puoli, jolla ei ole siirtovuoroa, on shakissa.', 'The side not to move is in check.'],
  'Dieses Schach kann so nicht entstanden sein.': ['Tällainen shakki ei ole voinut syntyä.', 'This check cannot have arisen.'],
  'Das Brett ist leer.': ['Lauta on tyhjä.', 'The board is empty.'],
  'Die Stellung ist nicht spielbar ({e}).': ['Asemaa ei voi pelata ({e}).', 'The position is not playable ({e}).'],
  'ziehen': ['siirrä', 'move'],
  'löschen': ['poista', 'delete'],
  'Am Zug': ['Siirtovuoro', 'To move'],
  'Rochade': ['Linnoitus', 'Castling'],
  'Grundstellung': ['Alkuasema', 'Starting position'],
  'Leeren': ['Tyhjennä', 'Clear'],
  'Drehen': ['Käännä', 'Flip'],
  'Unsicher erkannt: {s} (schraffiert). Prüfen und bei Bedarf korrigieren.': ['Epävarmasti tunnistettu: {s} (viivoitettu). Tarkista ja korjaa tarvittaessa.', 'Uncertain: {s} (hatched). Check and correct if needed.'],
  'Analysieren': ['Analysoi', 'Analyse'],

  // Foto
  'Das Bild konnte nicht gelesen werden ({e}).': ['Kuvaa ei voitu lukea ({e}).', 'The image could not be read ({e}).'],
  'Erkennung fehlgeschlagen: {e}': ['Tunnistus epäonnistui: {e}', 'Recognition failed: {e}'],
  'Schritt {n}': ['Vaihe {n}', 'Step {n}'],
  'Bild wählen': ['Valitse kuva', 'Choose image'],
  'Bildschirmfoto oder Buchdiagramm. Hierher ziehen oder mit ⌘V einfügen.': ['Kuvakaappaus tai kirjan diagrammi. Vedä tähän tai liitä ⌘V:llä.', 'Screenshot or book diagram. Drag it here or paste with ⌘V.'],
  'Das Bild bleibt auf diesem Rechner. Fotos echter Bretter von schräg oben kommen in einer späteren Stufe.': ['Kuva pysyy tällä koneella. Oikeiden lautojen viistokuvat tulevat myöhemmässä vaiheessa.', 'The image stays on this computer. Photos of real boards taken at an angle come in a later stage.'],
  'Brett finden': ['Etsi lauta', 'Find the board'],
  'Hochgeladenes Bild': ['Ladattu kuva', 'Uploaded image'],
  'erkenne …': ['tunnistetaan …', 'recognising …'],
  'Noch kein Bild.': ['Ei vielä kuvaa.', 'No image yet.'],
  'Sitzt der Rahmen nicht genau auf dem Brett, verschieben oder an der Ecke unten rechts vergrößern.': ['Jos kehys ei osu tarkasti laudalle, siirrä sitä tai muuta kokoa oikeasta alakulmasta.', 'If the frame is not exactly on the board, move it or resize it at the bottom-right corner.'],
  'Stellung prüfen': ['Tarkista asema', 'Check the position'],
  '1 unsicheres Feld': ['1 epävarma ruutu', '1 uncertain square'],
  '{n} unsichere Felder': ['{n} epävarmaa ruutua', '{n} uncertain squares'],
  ' (schraffiert). Bitte im Editor prüfen.': [' (viivoitettu). Tarkista editorissa.', ' (hatched). Please check in the editor.'],
  'Keine unsicheren Felder. Trotzdem kurz prüfen.': ['Ei epävarmoja ruutuja. Tarkista silti nopeasti.', 'No uncertain squares. Still, give it a quick check.'],
  'Das Bild zeigt das Brett aus Sicht von Schwarz; so wird es hier und im Editor auch gezeigt.': ['Kuva näyttää laudan mustan puolelta; niin se näytetään myös täällä ja editorissa.', "The image shows the board from Black's side; it is shown that way here and in the editor."],
  'Im Editor prüfen (Weiß am Zug)': ['Tarkista editorissa (valkean vuoro)', 'Check in the editor (White to move)'],
  'Schwarz am Zug': ['Mustan vuoro', 'Black to move'],

  // Wallpaper
  'Wallpaper-Einstellungen nicht geladen: {e}': ['Taustakuvan asetuksia ei voitu ladata: {e}', 'Wallpaper settings not loaded: {e}'],
  'Nicht gespeichert: {e}': ['Ei tallennettu: {e}', 'Not saved: {e}'],
  'Wähle in der Bibliothek Partien für das Wallpaper aus.': ['Valitse kirjastosta pelejä taustakuvaan.', 'Choose games for the wallpaper in the library.'],
  'Renderer': ['Renderöijä', 'Renderer'],
  'läuft (PID {p})': ['käynnissä (PID {p})', 'running (PID {p})'],
  'aus': ['pois', 'off'],
  'Partien': ['Pelit', 'Games'],
  'Wallpaper beenden': ['Lopeta taustakuva', 'Stop wallpaper'],
  'Wallpaper starten': ['Käynnistä taustakuva', 'Start wallpaper'],
  'gespeichert': ['tallennettu', 'saved'],
  'Renderer nicht gefunden unter {p}. Bauen mit: cd renderer && cargo build --release': ['Renderöijää ei löytynyt: {p}. Käännä: cd renderer && cargo build --release', 'Renderer not found at {p}. Build it with: cd renderer && cargo build --release'],
  'Playlist': ['Soittolista', 'Playlist'],
  'entfernen': ['poista', 'remove'],
  'Noch leer. In der Bibliothek das Häkchen „Wallpaper“ setzen.': ['Vielä tyhjä. Merkitse kirjastossa ruutu ”Taustakuva”.', 'Still empty. Tick “Wallpaper” in the library.'],
  'Einstellungen': ['Asetukset', 'Settings'],
  'Zugtempo': ['Siirtotahti', 'Move speed'],
  'Pause nach Partieende': ['Tauko pelin jälkeen', 'Pause after the game'],
  'Brettgröße': ['Laudan koko', 'Board size'],
  'Anteil der Bildschirmhöhe': ['osuus näytön korkeudesta', 'share of the screen height'],
  'Position': ['Sijainti', 'Position'],
  'Mitte': ['keskellä', 'centre'],
  'links': ['vasemmalla', 'left'],
  'rechts': ['oikealla', 'right'],
  'Brett': ['Lauta', 'Board'],
  'Nacht': ['Yö', 'Night'],
  'lichess braun': ['lichess ruskea', 'lichess brown'],
  'lichess blau': ['lichess sininen', 'lichess blue'],
  'Figuren': ['Nappulat', 'Pieces'],
  'Zuganimation': ['Siirtoanimaatio', 'Move animation'],
  'keine': ['ei mitään', 'none'],
  'schnell': ['nopea', 'fast'],
  'normal': ['normaali', 'normal'],
  'langsam': ['hidas', 'slow'],
  'Danach': ['Sen jälkeen', 'Afterwards'],
  'nächste Partie': ['seuraava peli', 'next game'],
  'wiederholen': ['toista', 'repeat'],
  'zufällig': ['satunnainen', 'random'],
  'Helligkeit': ['Kirkkaus', 'Brightness'],
  'Spielernamen': ['Pelaajien nimet', 'Player names'],
  'Jahr (wenn vorhanden)': ['Vuosi (jos tiedossa)', 'Year (if known)'],
  'aktueller Zug in Notation': ['nykyinen siirto notaationa', 'current move in notation'],
  'letzten Zug markieren': ['korosta viimeisin siirto', 'highlight the last move'],
  'Koordinaten': ['Koordinaatit', 'Coordinates'],
  'Sparsam': ['Virransäästö', 'Power saving'],
  'pausieren im Akkubetrieb': ['tauko akkukäytöllä', 'pause on battery'],
  'Außerdem pausiert der Renderer, wenn der Desktop verdeckt ist oder das Display schläft. Unter Linux fehlt das noch.': ['Lisäksi renderöijä pysähtyy, kun työpöytä on peitossa tai näyttö on lepotilassa. Linuxissa tämä puuttuu vielä.', 'The renderer also pauses when the desktop is covered or the display sleeps. Not yet available on Linux.'],

  // Setup
  'Setup nicht geladen: {e}': ['Asetuksia ei voitu ladata: {e}', 'Setup not loaded: {e}'],
  'König 8380A, Dame 8361A, Läufer 8351B, Springer 1031A, Turm 7370A, Bauer 8020D.': ['Kuningas 8380A, kuningatar 8361A, lähetti 8351B, ratsu 1031A, torni 7370A, sotilas 8020D.', 'King 8380A, queen 8361A, bishop 8351B, knight 1031A, rook 7370A, pawn 8020D.'],
  'Der klassische Satz von lichess.': ['lichessin klassinen sarja.', 'The classic lichess set.'],
  'Gilt für alle Bretter: Analyse, Spielen, Editor, Foto und Wallpaper.': ['Koskee kaikkia lautoja: analyysi, pelaaminen, editori, kuva ja taustakuva.', 'Applies to every board: analysis, play, editor, photo and wallpaper.'],
  'Beim Anmelden starten': ['Käynnistä kirjautuessa', 'Start at login'],
  'Startet den Server ohne Browserfenster; erreichbar über das Symbol in der Menüleiste.': ['Käynnistää palvelimen ilman selainikkunaa; avautuu valikkorivin kuvakkeesta.', 'Starts the server without a browser window; reachable via the menu bar icon.'],
  'Startet nur das Wallpaper mit der aktuellen Playlist. Braucht den Server nicht.': ['Käynnistää vain taustakuvan nykyisellä soittolistalla. Palvelinta ei tarvita.', 'Starts only the wallpaper with the current playlist. Does not need the server.'],
  'Engine': ['Moottori', 'Engine'],
  'gefunden': ['löytyi', 'found'],
  'nicht gefunden': ['ei löytynyt', 'not found'],
  'Stockfish startet nur, solange analysiert wird, und beendet sich nach zwei Minuten Leerlauf.': ['Stockfish on käynnissä vain analyysin ajan ja sulkeutuu kahden minuutin joutokäynnin jälkeen.', 'Stockfish only runs while analysing and quits after two idle minutes.'],
  'Wallpaper-Renderer': ['Taustakuvan renderöijä', 'Wallpaper renderer'],
  'Daten': ['Tiedot', 'Data'],
  'Bibliothek (schachserver.db), Wallpaper-Playlist und Protokoll des Renderers. Alles bleibt auf diesem Rechner.': ['Kirjasto (schachserver.db), taustakuvan soittolista ja renderöijän loki. Kaikki pysyy tällä koneella.', 'Library (schachserver.db), wallpaper playlist and renderer log. Everything stays on this computer.'],
  'Lizenzen': ['Lisenssit', 'Licences'],
  'Schachserver steht unter GPL-3.0. Es nutzt chessground, chessops und scalachess von lichess.org, Stockfish, Maia (CSSLab, Universität Toronto), Rodent IV und Figurensätze aus lila. Eröffnungsnamen und Rätsel stammen aus den lichess-Datenbanken (gemeinfrei, CC0).': ['Schachserver on GPL-3.0-lisensoitu. Se käyttää lichess.orgin chessgroundia, chessopsia ja scalachessia, Stockfishia, Maiaa (CSSLab, Toronton yliopisto), Rodent IV:tä sekä lilan nappulasarjoja. Avausten nimet ja tehtävät ovat lichessin tietokannoista (vapaa käyttö, CC0).', 'Schachserver is licensed under GPL-3.0. It uses chessground, chessops and scalachess from lichess.org, Stockfish, Maia (CSSLab, University of Toronto), Rodent IV and piece sets from lila. Opening names and puzzles come from the lichess databases (public domain, CC0).'],
  'Figurensätze und Urheber': ['Nappulasarjat ja tekijät', 'Piece sets and authors'],
  'Nur in der installierten App (beim Start aus dem Quellcode gibt es keinen Starter).': ['Vain asennetussa sovelluksessa (lähdekoodista käynnistettäessä käynnistintä ei ole).', 'Only in the installed app (there is no launcher when started from source).'],
  'Renderer nicht gefunden: {p}': ['Renderöijää ei löytynyt: {p}', 'Renderer not found: {p}'],
  'Öffentliche Demo · Bibliothek nur lesend · GPL-3.0': ['Julkinen demo · kirjasto vain luku · GPL-3.0', 'Public demo · library read-only · GPL-3.0'],
  'Noch keine Partien.': ['Ei vielä pelejä.', 'No games yet.'],
  'Gilt in diesem Browser für alle Bretter.': ['Koskee kaikkia lautoja tässä selaimessa.', 'Applies to every board in this browser.'],
  'Vollbild': ['Koko näyttö', 'Full screen'],
  'Vollbild (z)': ['Koko näyttö (z)', 'Full screen (z)'],
  'Vollbild beenden (Esc)': ['Poistu koko näytöstä (Esc)', 'Exit full screen (Esc)'],
  'Du': ['Sinä', 'You'],
  'Höchstens 16 Figuren je Seite.': ['Enintään 16 nappulaa kummallakin puolella.', 'At most 16 pieces per side.'],
  // Spielen
  'Spielen': ['Pelaa', 'Play'],
  'Gegen Bots spielen, aus Fehlern lernen, berühmte Partien nachspielen.': ['Pelaa botteja vastaan, opi virheistä, pelaa kuuluisia pelejä.', 'Play against bots, learn from mistakes, replay famous games.'],
  'volle Stärke': ['täysi vahvuus', 'full strength'],
  'Stockfish hat keinen Zug geliefert.': ['Stockfish ei antanut siirtoa.', 'Stockfish returned no move.'],
  'Matt. Du gewinnst.': ['Matti. Voitit.', 'Checkmate. You win.'],
  'Matt. Stockfish gewinnt.': ['Matti. Stockfish voitti.', 'Checkmate. Stockfish wins.'],
  'Patt. Remis.': ['Patti. Tasapeli.', 'Stalemate. Draw.'],
  'Zu wenig Material. Remis.': ['Riittämätön materiaali. Tasapeli.', 'Insufficient material. Draw.'],
  '50-Züge-Regel. Remis.': ['50 siirron sääntö. Tasapeli.', '50-move rule. Draw.'],
  'Dreimalige Wiederholung. Remis.': ['Kolmesti toistunut asema. Tasapeli.', 'Threefold repetition. Draw.'],
  'Spieler': ['Pelaaja', 'Player'],
  'Partie gegen Stockfish': ['Peli Stockfishia vastaan', 'Game against Stockfish'],
  'Stärke und Farbe wählen, dann „Neue Partie“.': ['Valitse vahvuus ja väri, sitten ”Uusi peli”.', 'Choose strength and colour, then “New game”.'],
  'Stockfish denkt …': ['Stockfish miettii …', 'Stockfish is thinking …'],
  'Du bist am Zug.': ['Sinun siirtosi.', 'Your move.'],
  'Gegner': ['Vastustaja', 'Opponent'],
  'Spielstärke': ['Pelivahvuus', 'Playing strength'],
  '{n} Stufen in 50er-Schritten über Stockfishs eingebaute Elo-Begrenzung (UCI_Elo). Die Werte sind Richtwerte.': ['{n} tasoa 50 Elon askelin Stockfishin sisäänrakennetulla Elo-rajoituksella (UCI_Elo). Arvot ovat suuntaa-antavia.', '{n} levels in 50-Elo steps via Stockfish’s built-in Elo limit (UCI_Elo). The values are approximate.'],
  'Ich spiele': ['Pelaan', 'I play'],
  'Zufall': ['Satunnainen', 'Random'],
  'Neue Partie': ['Uusi peli', 'New game'],
  'Du (Weiß)': ['Sinä (valkea)', 'You (White)'],
  'Du (Schwarz)': ['Sinä (musta)', 'You (Black)'],
  'Aufgeben': ['Luovuta', 'Resign'],
  'In der Bibliothek speichern': ['Tallenna kirjastoon', 'Save to library'],
  'Gespeichert. Zur Bibliothek': ['Tallennettu. Kirjastoon', 'Saved. Go to library'],
  'Umwandeln in {p}': ['Korota: {p}', 'Promote to {p}'],
};

function initial(): Lang {
  try {
    const q = new URLSearchParams(location.search).get('lang');
    if (q && (LANGS as string[]).includes(q)) {
      localStorage.setItem('schachserver.lang', q);
      return q as Lang;
    }
    const s = localStorage.getItem('schachserver.lang');
    if (s && (LANGS as string[]).includes(s)) return s as Lang;
  } catch {
    // ohne Speicher: Deutsch
  }
  return 'de';
}

Object.assign(D, MORE, MODES, BOTS, COACH, GUESS, PUZZLE, APP);

/** Alle Übersetzungen (für Tests) */
export const dictionary = (): Readonly<Record<string, [string, string]>> => D;

let lang: Lang = initial();
if (typeof document !== 'undefined') document.documentElement.lang = lang;

export const getLang = () => lang;

export function setLang(l: Lang) {
  lang = l;
  if (typeof document !== 'undefined') document.documentElement.lang = l;
  try {
    localStorage.setItem('schachserver.lang', l);
  } catch {
    // Wahl gilt dann nur bis zum Neuladen
  }
}

/** Zahlen- und Datumsformat der gewählten Sprache */
export const locale = () => ({ de: 'de-DE', fi: 'fi-FI', en: 'en-GB' })[lang];

const missing = new Set<string>();
export function t(de: string, vars?: Record<string, string | number>): string {
  let s = de;
  if (lang !== 'de') {
    const e = D[de];
    if (e) s = e[lang === 'fi' ? 0 : 1];
    else if (!missing.has(de)) {
      missing.add(de);
      if (typeof window !== 'undefined') (window as any).__i18nMissing = [...missing];
    }
  }
  return vars ? s.replace(/\{(\w+)\}/g, (_, k) => String(vars[k] ?? '')) : s;
}
